module.exports = __webpack_public_path__ + "assets/img/mask-twelve.ab5233d6.png";